import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Box, Divider } from '@material-ui/core';
import { usePageBallotCopyStyles } from '../styles';
import AppInput from '../../../../common/AppInput';

const genericError = 'Debe contener 8 o 9 dígitos';

const BallotInvoiceCopy = (props) => {
  const { mobile } = props;
  const [orderId, setOrderId] = useState('');
  const [errorMessage, setErrorMessage] = useState(genericError);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const classes = usePageBallotCopyStyles({ mobile });

  const onChangeOrderId = (event) => {
    const { value } = event.target;
    setOrderId(value);
    const isNum = /^\d+$/.test(value);
    if (!isNum) {
      setErrorMessage('Debe ser un valor númerico');
      setError(true);
      setSuccess(false);
      setDisabled(true);
    } else {
      if (value.length < 8 || value.length > 9) {
        setErrorMessage(genericError);
        setError(true);
        setSuccess(false);
        setDisabled(true);
      } else {
        setError(false);
        setSuccess(true);
        setDisabled(false);
      }
    }
  };

  return (
    <Box
      className={classes.container}
      margin={mobile ? '0px -16px' : ''}
      width={mobile ? 'auto' : '75%'}
    >
      <Typography className={classes.title}>
        Solicita una copia de tu boleta, ingresando el número de orden de
        compra.
      </Typography>
      <Divider />
      <AppInput
        name="orderId"
        required
        helperText={'Ingresar 8 o 9 dígitos'}
        label={'Nº orden de compra'}
        value={orderId}
        onClick={onChangeOrderId}
        onBlur={onChangeOrderId}
        onChange={onChangeOrderId}
        error={error}
        errorMessage={errorMessage}
        success={success}
      />
      <div className={classes.contButton}>
        <Button
          className={classes.sendButton}
          variant="contained"
          color="primary"
          disabled={disabled}
        >
          Enviar
        </Button>
      </div>
    </Box>
  );
};

BallotInvoiceCopy.propTypes = {
  mobile: PropTypes.bool,
};

export default BallotInvoiceCopy;
